import { MetaData } from "@qid/core";
import { Organisation } from "../../organisation";

export class AuthKey extends MetaData {
  _id: string;
  createdBy: string;
  org: Organisation;
  secret: string;
  whitelistedOrigins: string[];
  hash: string;
  tokenId: string;
  featuresAllowed: string[];
  name: string;

  constructor() {
    super();
  }
}


